<template>
  <div class="pb-terms d-flex flex-column gap-2">
    <span v-for="item in cartItems" :key="item.id" class="w-100 summary-block d-flex flex-column justify-content-between gap-2">
      <div class="w-100 summary-block d-flex flex-column justify-content-between gap-1 mb-0">
        <div class="summary-row pb-2 pb-md-0 d-flex flex-row justify-content-between gap-2 w-100">
          <div class="pl-0 pr-0 pb-10 pb-md-0 text-start flex-grow-1">
            <span class="fw-semibold pull-left space-after">{{ item.title }}</span>
          </div>
          <span class="text-end" :key="getItemTermPrice(item)">
            ${{ getItemTermPrice(item) }}
            <span v-if="item.options.term_type === 'monthly'">{{ $t('common.mo') }}</span>
            <span v-if="item.options.term_type === 'annually'">{{ $tc('common.yr') }}</span>
          </span>
        </div>
        <div class="summary-row pb-2 pb-md-0 d-flex flex-row justify-content-between gap-2 w-100">
          <span class="pull-left-md d-block domain">{{ item.options.domain }}</span>
          <span class="pull-right-md justify-content-end">
            <span v-if="item.options.term_type === 'annually' && item.term > 1">({{ item.term }} {{ $tc('common.year', item.term) }})</span>
            <span v-if="item.options.term_type === 'monthly' && item.term > 1">({{ item.term }} {{ $tc('common.month', item.term) }})</span>
          </span>
        </div>
      </div>
      <div class="w-100 summary-row" v-show="getFirstTermMultiYearDiscountedPrice(item)">
        <span class="d-flex pb-2 pb-md-0 flex-row justify-content-between gap-2">
          <div class="col-md-9 pl-0 pr-0">
            <span class="pull-left fw-semibold pr-5">First Year ${{ getFirstTermMultiYearDiscountedPrice(item) }}:</span>
          </div>
          <span class="pull-right">(${{ getFirstTermMultiYearDiscount(item) }})</span>
        </span>
      </div>

      <span v-for="item in getAddonItemsFor(item.id)" :key="item.id">
        <div class="w-100 d-block summary-block pr-5">
          <div class="summary-row pb-2 pb-md-0 d-flex flex-row justify-content-between gap-2 w-100">
            <div class="col-md-9 col-xs-12 pl-0 pr-0 pb-10 pb-md-0">
              <span class="text-semibold pull-left space-after">{{ item.title }}</span>
              <span v-if="item.product_id === 'team.login'" class="text-semibold pull-left space-after">{{ item.options.quantity }} seat(s)</span>
            </div>
            <span class="pull-right-md">
              ${{ getItemTermPrice(item) }}
              <span v-if="item.options.term_type === 'monthly'">{{ $t('common.mo') }}</span>
              <span v-if="item.options.term_type === 'annually'">{{ $tc('common.yr') }}</span>
            </span>
          </div>
          <div class="summary-row pb-2 pb-md-0 d-flex flex-row justify-content-between gap-2 w-100">
            <span class="pull-left-md d-block domain">{{ item.options.domain }}</span>
            <span class="pull-right-md">
              <span v-if="item.options.term_type === 'annually' && item.term > 1">({{ item.term }} {{ $tc('common.year', item.term) }})</span>
            </span>
          </div>
        </div>
      </span>
    </span>

    <!-- cart part-->
    <div id="totals-row" class="w-100 d-block summary-block border-top border-1 pt-3 mt-2 border-noip-logo-grey w-100 summary-block d-flex flex-column justify-content-between gap-2">
      <div class="w-100 summary-block border-bottom-1 pb-3 border-noip-logo-grey" v-if="authenticated">
        <div class="w-100 d-block">
          <div class="pull-left w-100 mb-0 d-flex flex-row gap-0 cc-success">
            <div class="w-100 pl-0 pr-0">
              <input @keyup.enter="submitDiscountCode" v-model="coupon_code" placeholder="Coupon Code" class="form-control active" type="text" />
            </div>
            <div class="pull-left d-inline pb-w-100-btn pt-10 pt-md-0 ms-n1">
              <button @click="submitDiscountCode" v-track="{ category: 'plan-builder', action: 'click', label: 'submit_couponcode' }" class="btn btn-pb-cc fw-bold pb-buttons-padding">{{ $t('plan_builder.apply') }}</button>
            </div>
          </div>
        </div>
        <div v-if="loading" class="w-100 pull-left pt-15">
          <span class="text-info-xl text-sm">{{ 'common.adjusting_preview' }}...</span>
        </div>
        <div id="coupon-error" class="w-100 pull-left pt-15" v-if="show_coupon_code_error">
          <div class="text-danger fs-7">
            <span class="fw-semibold">{{ $t('common.coupon_code_is_not_valid') }}</span>
            <br />
            {{ $t('common.contact_support_if_you_believe_this_is_an_error') }}
          </div>
        </div>
        <div v-if="invoicePreview.discount_error" class="w-100 pull-left pt-15">
          <div class="text-danger text-sm">
            <span class="fw-semibold">{{ invoicePreview.discount_error }}</span>
            <br />
            {{ $t('common.contact_support_if_you_believe_this_is_an_error') }}
          </div>
        </div>
      </div>
      <div class="summary-row pb-15 w-100 summary-block d-flex flex-row justify-content-between gap-2">
        <span class="pull-left fw-semibold">{{ $t('common.sub_total') }}:</span>
        <span class="pull-right js-cart-total title mb-0">
          <span class="js-cart-total fw-semibold" :key="cartTotal.toFixed(2)">${{ cartTotal.toFixed(2) }}</span>
        </span>
      </div>
      <div class="w-100 summary-row pb-15 pull-left w-100 summary-block flex-row justify-content-between gap-2" v-show="discountsTotal > 0">
        <span>
          <div class="col-md-9 pl-0 pr-0">
            <span class="pull-left fw-semibold pr-5">{{ $t('common.coupon_applied') }}:</span>
            <span class="pull-left text-normal">{{ invoicePreview.wanted_discount_name }}</span>
          </div>
          <span class="pull-right">(${{ discountsTotal.toFixed(2) }})</span>
        </span>
      </div>
      <div class="w-100 summary-row pb-15 pull-left w-100 summary-block d-flex flex-row justify-content-between gap-2" v-if="invoicePreview.credits > '$0.00'">
        <span class="pull-left fw-semibold">{{ $t('Available credit') }}:</span>
        <span class="pull-right js-cart-total title mb-0">
          <span class="js-cart-total fw-semibold">{{ invoicePreview.credits }}</span>
        </span>
      </div>
      <div class="w-100 summary-row pb-15 pull-left w-100 summary-block d-flex flex-row justify-content-between gap-2" v-if="invoicePreview.credits_used > '$0.00'">
        <span class="pull-left fw-semibold">{{ $t('common.credit_used') }}:</span>
        <span class="pull-right js-cart-total title mb-0">
          <span class="js-cart-total fw-semibold">{{ invoicePreview.credits_used }}</span>
        </span>
      </div>

      <div class="summary-row w-100 summary-block d-flex flex-row justify-content-between gap-2">
        <span class="pull-left fw-semibold">{{ $t('plan_builder.total') }}:</span>
        <span class="pull-right js-cart-total title mb-0">
          <span class="js-cart-total fw-semibold" id="amount-due" :key="invoicePreview.amount_due">{{ invoicePreview.amount_due }}</span>
        </span>
      </div>
    </div>
    <div v-if="hasEmailPromo && !authenticated" class="w-100 pull-left pt-15 w-100 summary-block d-flex flex-row justify-content-between gap-2">
      <div class="alert alert-warning mb-0">{{ $t('common.coupon_code_will_be_applied_once_logged_in') }}</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'OrderSummary',

  data() {
    return {
      coupon_code: '',
      show_coupon_code_error: '',
      loading: false
    };
  },

  props: {
    cartTotal: {
      type: Number,
      required: true
    },

    invoicePreview: {
      type: Object,
      required: true
    },

    cartItems: {
      type: Array,
      required: true
    },

    authenticated: {
      type: Boolean,
      required: true
    },

    addonItems: {
      type: Array
    },

    hasEmailPromo: {
      type: Boolean
    }
  },
  watch: {
    cartItems() {
      if (this.coupon_code) {
        this.submitDiscountCode();
      }
    }
  },
  computed: {
    discountsTotal() {
      return this.invoiceItemDiscountTotal + this.invoiceDiscountTotal;
    },
    invoiceItemDiscountTotal() {
      return (this.invoicePreview.applied_invoice_item_discounts || []).map(({ amount }) => parseFloat(amount)).reduce((a, b) => a + b, 0);
    },
    invoiceDiscountTotal() {
      return (this.invoicePreview.applied_invoice_discounts || []).map(({ amount }) => parseFloat(amount)).reduce((a, b) => a + b, 0);
    }
  },

  methods: {
    ...mapActions('cart', ['addDiscount']),

    submitDiscountCode() {
      this.loading = true;
      // eslint-disable-next-line no-undef
      axios
        .get('/cart/checkout/discount-exists?discount=' + this.coupon_code)
        .then(response => {
          if (this.show_coupon_code_error) {
            this.loading = false;
            this.show_coupon_code_error = false;
          }
          if (response.data.exists === true) {
            this.loading = false;
            this.addDiscount({ coupon_code: this.coupon_code });
          } else {
            this.loading = false;
            this.show_coupon_code_error = true;
          }
        })
        .catch(() => {
          this.loading = false;
          this.show_coupon_code_error = true;
        });
    },
    getItemTermPrice(item) {
      if (item.discount === undefined || !item.discount || this.getFirstTermMultiYearDiscountedPrice(item)) {
        return item.price;
      }

      return (item.price - item.discount / item.term).toFixed(2);
    },

    getFirstTermMultiYearDiscountedPrice(item) {
      if (item.first_term_discounts === undefined || !(item.term in item.first_term_discounts)) {
        return;
      }

      const price = item.price - item.first_term_discounts[item.term];
      return price.toFixed(2);
    },

    getFirstTermMultiYearDiscount(item) {
      const first_term_discounted_price = this.getFirstTermMultiYearDiscountedPrice(item);
      if (!first_term_discounted_price) {
        return '';
      }

      const discount = item.price - first_term_discounted_price;

      return discount.toFixed(2);
    },

    getAddonItemsFor(parent_Id) {
      if (!Array.isArray(this.addonItems)) {
        return [];
      }
      return this.addonItems.filter(addOn => addOn.parent_id == parent_Id);
    }
  }
};
</script>
